import { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const FAQ_ITEMS = [
  {
    q: 'Come funziona il traduttore di referti medici?',
    a: 'Carica il tuo referto medico in formato PDF o come foto scattata con lo smartphone. La nostra intelligenza artificiale lo analizza e lo traduce in linguaggio semplice e comprensibile in pochi secondi.',
  },
  {
    q: 'Il servizio è gratuito?',
    a: 'Sì, puoi tradurre fino a 3 referti medici gratuitamente ogni mese con il piano base. Il piano Pro offre fino a 100 traduzioni al mese per professionisti del settore sanitario che ne necessitano.',
  },
  {
    q: 'I miei dati medici sono al sicuro?',
    a: 'Assolutamente sì. Utilizziamo al momento una politica "No Logs" e non abbiamo accesso alle informazioni riportate nei referti medici rispettando pienamente la normativa vigente.',
  },
  {
    q: 'Quali tipi di file posso caricare?',
    a: 'Puoi caricare referti in formato PDF oppure immagini (JPG, PNG) — anche semplici foto scattate con lo smartphone.',
  },
  {
    q: 'Posso usarlo dallo smartphone?',
    a: 'Sì, TRM è ottimizzato per smartphone e tablet. Puoi anche installarlo come app gratuita direttamente sulla tua Home per averlo sempre a portata di mano.',
  },
  {
    q: 'La traduzione AI sostituisce il parere del medico?',
    a: 'No. TRM è uno strumento di supporto per comprendere meglio i propri referti, ma non sostituisce mai la consulenza medica. Per qualsiasi dubbio clinico ti invitiamo sempre a consultare il tuo medico di base o uno specialista.',
  },
  {
    q: 'Quanto tempo ci vuole per tradurre un referto?',
    a: 'Circa 60 secondi. Il sistema AI elabora i referti in tempo reale: dalla foto o dal PDF al testo spiegato in italiano semplice, senza attese.',
  },
  {
    q: 'Devo registrarmi o creare un account?',
    a: 'No. Al momento, non è necessaria alcuna registrazione né email. Puoi usare TRM immediatamente, direttamente dal browser, senza creare account.',
  },
];

const FAQItem = ({ q, a, open, onToggle }) => (
  <Box
    component="div"
    sx={{
      borderBottom: '1px solid var(--e-border, #B2DDD8)',
      '&:first-of-type': { borderTop: '1px solid var(--e-border, #B2DDD8)' },
    }}
  >
    <Box
      component="button"
      onClick={onToggle}
      aria-expanded={open}
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        py: 2,
        px: 0,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        color: 'var(--e-text-1, #0D2B27)',
        fontFamily: 'var(--f-body, Poppins, sans-serif)',
        fontWeight: 600,
        fontSize: '0.97rem',
        lineHeight: 1.45,
        '&:hover': { color: 'var(--e-primary, #00897B)' },
        transition: 'color 0.15s ease',
      }}
    >
      <span>{q}</span>
      {open
        ? <RemoveIcon sx={{ flexShrink: 0, fontSize: '1.1rem', color: 'var(--e-primary, #00897B)' }} />
        : <AddIcon sx={{ flexShrink: 0, fontSize: '1.1rem', color: 'var(--e-text-3, #7AADA6)' }} />
      }
    </Box>
    <Collapse in={open} timeout={200}>
      <Typography
        variant="body2"
        sx={{
          pb: 2,
          color: 'var(--e-text-2, #3D6B64)',
          fontSize: '0.9rem',
          lineHeight: 1.7,
        }}
      >
        {a}
      </Typography>
    </Collapse>
  </Box>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <Box
      component="section"
      aria-labelledby="faq-heading"
      sx={{ mt: 5, mb: 2, px: { xs: 2, sm: 0 } }}
    >
      <Typography
        id="faq-heading"
        variant="h2"
        sx={{
          fontFamily: 'var(--f-display, Syne, sans-serif)',
          fontSize: { xs: '1.25rem', sm: '1.4rem' },
          fontWeight: 700,
          color: 'var(--e-text-1, #0D2B27)',
          mb: 2.5,
        }}
      >
        Domande frequenti
      </Typography>

      {FAQ_ITEMS.map((item, i) => (
        <FAQItem
          key={i}
          q={item.q}
          a={item.a}
          open={openIdx === i}
          onToggle={() => setOpenIdx(openIdx === i ? null : i)}
        />
      ))}
    </Box>
  );
};

export default FAQ;
